import { useState } from 'react';
import { Col, Row } from 'reactstrap';
import './PerformanceKPI.scss';

function PeroformanceKPIHeader() {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="description fs-6">
      <Row className="align-items-center">
        {/* Icon + Title + Content */}
        <Col md={11}>
          <p className="mb-2 text-dark">
            <strong className="PCM-heading">Purpose:</strong>{' '}
            <span>
              This section is designed to define, track, and evaluate your
            </span>{' '}
            <strong>qualitative performance objectives—</strong>{' '}
            <span>
              the key outcomes you are expected to deliver over a specific time
              period.
            </span>
          </p>
          <p className="mb-2 text-dark">
            <strong className="PCM-heading">Key Points:</strong>
          </p>
          <ul className="mb-2 ps-3 text-dark">
            <li className="mb-2">
              <strong className="PCM-heading">Performance Objectives:</strong>{' '}
              <span>These are</span> <strong>specific, measurable</strong>{' '}
              <span>
                results that align with your role and contribute to the broader
                goals of your team or organization.
              </span>
            </li>
            {!expanded && (
              <li style={{ listStyle: 'none' }}>
                <button
                  type="button"
                  className="non-btn see-more-expand"
                  onClick={() => setExpanded(true)}
                >
                  See More
                </button>
              </li>
            )}
            <div className={`expandable-performance ${expanded ? 'open' : ''}`}>
              <li className="mb-2">
                <div className="mb-2">
                  <span>Each objective should follow the</span>{' '}
                  <strong>SMART</strong> <span>criteria:</span>
                </div>
                <ul>
                  <li className="mb-1">
                    <strong>S</strong>pecific: Clear and focused
                  </li>
                  <li className="mb-1">
                    <strong>M</strong>easurable: Quantifiable or observable
                  </li>
                  <li className="mb-1">
                    <strong>A</strong>chievable: Realistic given resources and
                    constraints
                  </li>
                  <li className="mb-1">
                    <strong>R</strong>elevant: Aligned with your role or
                    organizational priorities
                  </li>
                  <li>
                    <strong>T</strong>ime-bound: Has a deadline or defined
                    period
                  </li>
                </ul>
              </li>
              <li className="mb-2">
                <strong className="PCM-heading">Weights:</strong>{' '}
                <span>
                  Each objective will be assigned a weight (by your manager) to
                  indicate its
                </span>{' '}
                <strong>relative importance.</strong> <span>The</span>{' '}
                <strong>total weight for this section must equal 60%</strong>{' '}
                <span> of your overall evaluation.</span>
              </li>
              <li className="mb-2">
                <div className="mb-2">
                  <strong className="PCM-heading">Comments:</strong>{' '}
                  <span>Below each performance objective, there is a</span>{' '}
                  <strong>comment box.</strong>{' '}
                  <span>
                    This space allows add comments which is visible to public.
                  </span>
                </div>
                <ul>
                  <li className="mb-1">Clarify expectations</li>
                  <li className="mb-1">Provide progress updates</li>
                  <li className="mb-1">
                    Reflect on achievements or challenges
                  </li>
                  <li>Add context or insights</li>
                </ul>
              </li>
            </div>
            {expanded && (
              <li style={{ listStyle: 'none' }}>
                <button
                  type="button"
                  onClick={() => setExpanded(false)}
                  className="non-btn see-more-expand"
                >
                  Hide
                </button>
              </li>
            )}
          </ul>
        </Col>
      </Row>
    </div>
  );
}

export default PeroformanceKPIHeader;
